module.exports = __webpack_public_path__ + "img/stopwatch.3cde8ad4.png";